import {getAuth, onAuthStateChanged} from "firebase/auth";
import {getDatabase, ref, child, get} from "firebase/database";
import User from "../../../models/user";

const logout = async () => {
    const auth = getAuth();
    await auth.signOut();
}

export default logout;